<script setup lang="ts">
import { PROBLEMS } from '../content/problems'

const emit = defineEmits<{ select: [symptom: string] }>()
</script>

<template>
    <section id="problems" class="site-section">
        <div class="site-content">
            <h2>What's going on with your system?</h2>
            <p class="muted">Pick the closest match — the guided diagnosis starts immediately.</p>
            <div class="cards">
                <button
                    v-for="p in PROBLEMS"
                    :key="p.value"
                    class="glass problem-card"
                    type="button"
                    @click="emit('select', p.value)"
                >
                    <span class="emoji" aria-hidden="true">{{ p.emoji }}</span>
                    <span class="label">{{ p.label }}</span>
                    <span class="blurb muted">{{ p.blurb }}</span>
                </button>
            </div>
        </div>
    </section>
</template>

<style scoped lang="scss">
.cards {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: var(--site-space-md);
    margin-top: var(--site-space-lg);
}

.problem-card {
    display: flex;
    flex-direction: column;
    gap: var(--site-space-xs);
    padding: var(--site-space-lg);
    text-align: left;
    cursor: pointer;
    color: var(--site-text);
    font-family: var(--site-font-body);
    transition: transform 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;

    .emoji {
        font-size: 1.8rem;
    }

    .label {
        font-weight: 700;
        font-size: 1.05rem;
    }

    .blurb {
        font-size: 0.85rem;
    }

    &:hover {
        transform: translateY(-3px);
        border-color: var(--site-accent);
        box-shadow: var(--site-glow);
    }
}
</style>
